// extracted by mini-css-extract-plugin
export default {"headerTabs":"ueSufIxWxYpgQReygm66","headerTabsMobile":"FeCyks6JLXjBx7OALpaT","tabsExtraContent":"Gk5QC8E4cho7mvYoAZ2C","tableRow":"ehl3FOv7n7JLmgRbVPIB"};